export default __webpack_public_path__ + "static/media/TWraps.54e80479.png";